import { Component } from "react";

import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import { ReactComponent as Info } from "../assets/icons/information.svg";
import { ReactComponent as Error } from "../assets/icons/error.svg";
import { ReactComponent as Success } from "../assets/icons/success.svg";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import colors from "../constants/colors";
import { hideSnackbar } from "../features/snackbar/snackbar.actions";
import {
  getSnackbarProps,
  isSnackbarOpened,
} from "../features/snackbar/snackbar.selectors";

class AppSnackbar extends Component {
  static propTypes = {
    message: PropTypes.string,
    variant: PropTypes.oneOf(["success", "error", "info"]),
    style: PropTypes.object,
    open: PropTypes.bool,
    hideSnackbar: PropTypes.func,
  };

  onClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    this.props.hideSnackbar();
  };

  render() {
    const { message, open, hideSnackbar, variant, style } = this.props;

    const variantConfig = {
      success: {
        background: "#2E7D32",
        icon: Success,
      },
      error: {
        background: colors.buttonGradient,
        icon: Error,
      },
      info: {
        background: "#0288D1",
        icon: Info,
      },
    };

    const config = variantConfig[variant] || variantConfig.error;
    const backgroundColor = style?.background || config.background;
    const IconComponent = config.icon;

    const messageWithIcon = (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <IconComponent style={{ color: "white" }} />
        <span>{message}</span>
      </div>
    );

    return (
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={open}
        autoHideDuration={4000}
        onClick={hideSnackbar}
        onClose={this.onClose}
      >
        <SnackbarContent
          style={{ background: backgroundColor }}
          message={messageWithIcon}
        />
      </Snackbar>
    );
  }
}

export default connect(
  (state) => {
    const props = getSnackbarProps(state);
    return {
      message: props.message,
      variant: props.variant,
      style: props.style,
      open: isSnackbarOpened(state),
    };
  },
  { hideSnackbar }
)(AppSnackbar);
